import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { errorsReducer as errors } from './errors';
import { sessionReducer as session } from './session';
import { positionsReducer as positions } from './positions';
import throttleMiddleware from './throttleMiddleware';

// Sessions and the tracking projection only. The tracking application this was forked from also
// cached devices, events, geofences, groups, drivers and maintenance here; those screens are gone,
// and the operational data they duplicated is served by OperationsProvider from one bootstrap.
const combinedReducer = combineReducers({
  errors,
  session,
  positions,
});

// Never retain one user's operational data in the next authenticated session.
const reducer = (state, action) => {
  if (action.type === 'session/updateUser' && state
    && (state.session.user?.id !== action.payload?.id || state.session.user?.tenantId !== action.payload?.tenantId)) {
    return combinedReducer({ session: { ...state.session, user: null, socket: null } }, action);
  }
  return combinedReducer(state, action);
};

export { errorsActions } from './errors';
export { sessionActions } from './session';
export { positionsActions } from './positions';

export default configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(throttleMiddleware),
});
